import { render, staticRenderFns } from "./qr-generator-test.vue?vue&type=template&id=38f314fb&scoped=true&"
import script from "./qr-generator-test.vue?vue&type=script&lang=js&"
export * from "./qr-generator-test.vue?vue&type=script&lang=js&"
import style0 from "./qr-generator-test.vue?vue&type=style&index=0&id=38f314fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f314fb",
  null
  
)

export default component.exports